'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var Icons = require('./Icons-46f5553f.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".DiamondRating_module_visuallyHidden__3cf98ec6 {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.DiamondRating_module_youtubeVideo__3cf98ec6 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.DiamondRating_module_DiamondReturn__3cf98ec6 {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n}\n\n.DiamondRating_module_InspectedClean__3cf98ec6, .DiamondRating_module_OpenTable__3cf98ec6 {\n  margin-top: 4px;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Molecules/DiamondRating/DiamondRating.module.scss");
var modules_9b2b1943 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"DiamondRating_module_visuallyHidden__3cf98ec6","youtubeVideo":"DiamondRating_module_youtubeVideo__3cf98ec6","DiamondReturn":"DiamondRating_module_DiamondReturn__3cf98ec6","InspectedClean":"DiamondRating_module_InspectedClean__3cf98ec6","OpenTable":"DiamondRating_module_OpenTable__3cf98ec6"};

function DiamondRating(_ref) {
  var diamondIcon = _ref.diamondIcon,
    diamondWidth = _ref.diamondWidth,
    diamondHeight = _ref.diamondHeight,
    inspectedClean = _ref.inspectedClean,
    openTable = _ref.openTable,
    extraClass = _ref.extraClass;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_9b2b1943.DiamondReturn, extraClass].join(" ")
  }, diamondIcon ? /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    iconHSize: diamondHeight,
    iconName: diamondIcon,
    iconWSize: diamondWidth,
    ariaHidden: false
  }) : null, inspectedClean ? /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    extraClass: modules_9b2b1943.InspectedClean,
    iconHSize: 40,
    iconName: "inspected-clean",
    iconWSize: 140,
    ariaHidden: false
  }) : null, openTable ? /*#__PURE__*/React__default["default"].createElement(Icons.Icon, {
    extraClass: modules_9b2b1943.OpenTable,
    iconHSize: 26,
    iconName: "open-table-logo-one-color",
    iconWSize: 116,
    ariaHidden: false,
    iconColor: "#191919"
  }) : null));
}
DiamondRating.propTypes = {
  extraClass: index.propTypes.exports.string,
  diamondIcon: index.propTypes.exports.string,
  diamondWidth: index.propTypes.exports.number,
  diamondHeight: index.propTypes.exports.number,
  inspectedClean: index.propTypes.exports.bool
};

exports.DiamondRating = DiamondRating;
